import { useEffect } from "react";
import { isDefined } from "src/common/utils/filters/isDefined.ts";
import { useMaybeLoadedCompanyDomain } from "src/routes/routeDataHooks";

const siteName = "Exopen";
const SEPARATOR = " · ";

export const useDocumentTitle = (
	title?: string | (string | undefined)[] | undefined,
) => {
	const companyDomain = useMaybeLoadedCompanyDomain();

	useEffect(() => {
		if (title === undefined) {
			return;
		}

		if (title === "") {
			document.title = companyDomain?.company.name ?? siteName;
		} else {
			document.title = [title, companyDomain?.company.name ?? siteName]
				.flat()
				.filter(isDefined)
				.join(` ${SEPARATOR} `);
		}
	}, [title, companyDomain?.company.name]);
};
